module.exports = __webpack_public_path__ + "static/media/6.734553a2.jpg";